import React from "react";

const License = () => {
  return (
    <div>

      {/* HERO */}
      <section className="hero">
        <div className="container">
          <h1>Export License</h1>
          <p>DGFT Export Licensing consultancy</p>
        </div>
      </section>

      {/* CONTENT */}
      <section className="section">
        <div className="container">

          <h2>Export License Services</h2>

          <p>
            Some export products require DGFT approval before shipping.
            We assist businesses in obtaining required export licenses.
          </p>

          <br />

          <div className="card">
            <h3>We Help With</h3>
            <p>✔ License eligibility check</p>
            <p>✔ Application preparation</p>
            <p>✔ DGFT liaison support</p>
            <p>✔ Approval tracking</p>
          </div>

        </div>
      </section>

    </div>
  );
};

export default License;
